module.exports = __webpack_public_path__ + "img/05.8e431d3d.jpg";